module.exports = __webpack_public_path__ + "static/media/VIIIh.210344b1.png";